import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as configsActions from "../../actions/configuracoes";
import { Notification, notify } from "../../utils/notification";

const emptyForm = () => ({
	nome: "",
	secretKey: "",
});

function ConfigPayments({ loja, usuario, getConfiguracao, updatePagarme, validatePagarmeConta }) {
	const [notification, setNotification] = useState("");
	const [contas, setContas] = useState([]);
	const [contaAtivaId, setContaAtivaId] = useState(null);
	const [formState, setFormState] = useState(emptyForm());
	const [editingId, setEditingId] = useState(null);
	const [saving, setSaving] = useState(false);
	const [validatingId, setValidatingId] = useState(null);
	const [validatingForm, setValidatingForm] = useState(false);

	const isMaskedKey = (value) => typeof value === "string" && value.includes("****");

	useEffect(() => {
		if (usuario?.loja) getConfiguracao(usuario.loja);
	}, [usuario?.loja, getConfiguracao]);

	useEffect(() => {
		const pagarme = loja?.paymentGateways?.pagarme;
		if (!pagarme) return;
		setContas((pagarme.contas || []).map((conta) => ({
			...conta,
			contaId: conta.contaId || conta.id,
		})));
		setContaAtivaId(pagarme.contaAtivaId || null);
	}, [loja]);

	const resetForm = () => {
		setFormState(emptyForm());
		setEditingId(null);
	};

	const handleEdit = (conta) => {
		setEditingId(conta.contaId);
		setFormState({
			nome: conta.nome,
			secretKey: conta.secretKeyMasked || "",
		});
	};

	const handleSave = (event) => {
		event.preventDefault();
		if (!loja?._id) return notify("Loja não carregada.", setNotification, "error");
		if (!formState.nome.trim()) return notify("Informe o nome da conta.", setNotification, "error");
		if (!editingId && !formState.secretKey.trim()) {
			return notify("Informe a chave secreta da Pagarme.", setNotification, "error");
		}

		const payloadContas = editingId ? [{
			contaId: editingId,
			nome: formState.nome.trim(),
			secretKey: formState.secretKey.trim(),
		}] : [{
			nome: formState.nome.trim(),
			secretKey: formState.secretKey.trim(),
		}];

		setSaving(true);
		updatePagarme({
			contaAtivaId,
			contas: payloadContas,
		}, loja._id, (error) => {
			setSaving(false);
			if (error) return notify(error.message || "Erro ao salvar conta Pagarme.", setNotification, "error");
			notify(editingId ? "Conta atualizada com sucesso!" : "Conta cadastrada com sucesso!", setNotification, "success");
			resetForm();
		});
	};

	const handleActivate = (conta) => {
		if (!loja?._id || contaAtivaId === conta.contaId) return;
		if (conta.sandbox) {
			return notify("Esta conta não pode ser definida como ativa.", setNotification, "error");
		}

		setSaving(true);
		updatePagarme({ contaAtivaId: conta.contaId }, loja._id, (error) => {
			setSaving(false);
			if (error) return notify(error.message || "Erro ao trocar conta ativa.", setNotification, "error");
			setContaAtivaId(conta.contaId);
			notify("Conta Pagarme ativa alterada com sucesso!", setNotification, "success");
		});
	};

	const handleValidate = (payload, validatingKey) => {
		if (!loja?._id) return notify("Loja não carregada.", setNotification, "error");

		if (validatingKey === "form") setValidatingForm(true);
		else setValidatingId(validatingKey);

		validatePagarmeConta(payload, loja._id, (error, result) => {
			if (validatingKey === "form") setValidatingForm(false);
			else setValidatingId(null);

			if (error) return notify(error.message || "Erro ao validar chave.", setNotification, "error");

			notify(
				result?.valid ? "Chave válida." : (result?.message || "Chave inválida."),
				setNotification,
				result?.valid ? "success" : "error"
			);
		});
	};

	const handleValidateConta = (contaId) => {
		handleValidate({ contaId }, contaId);
	};

	const handleValidateForm = () => {
		if (formState.secretKey.trim() && !isMaskedKey(formState.secretKey)) {
			return handleValidate({ secretKey: formState.secretKey.trim() }, "form");
		}
		if (editingId) {
			return handleValidate({ contaId: editingId }, "form");
		}
		return notify("Informe a chave secreta para validar.", setNotification, "error");
	};

	const handleRemove = (conta) => {
		if (!loja?._id) return;
		if (conta.contaId === contaAtivaId) {
			return notify("Não é possível remover a conta ativa.", setNotification, "error");
		}
		if (!window.confirm(`Remover a conta "${conta.nome}"?`)) return;

		setSaving(true);
		updatePagarme({
			contaAtivaId,
			contas: [{ contaId: conta.contaId, _remove: true }],
		}, loja._id, (error) => {
			setSaving(false);
			if (error) return notify(error.message || "Erro ao remover conta.", setNotification, "error");
			if (editingId === conta.contaId) resetForm();
			notify("Conta removida com sucesso!", setNotification, "success");
		});
	};

	return (
		<div className="config-payments">
			<Notification notification={notification} />

			<h3>
				<span className="new">PAGARME</span>
				Contas cadastradas
				<span className="success-label">na loja</span>
			</h3>

			<p className="config-payments-help">
				Cadastre as contas Pagarme e escolha qual delas receberá os novos pagamentos.
			</p>

			<div className="list">
				{contas.length === 0 && (
					<p className="config-payments-empty">Nenhuma conta cadastrada.</p>
				)}
				{contas.map((conta) => (
					<div key={conta.contaId} className={`item ${conta.contaId === contaAtivaId ? "active" : ""}`}>
						<div className="info">
							<label>Conta</label>
							<span className="conta-nome">
								{conta.nome}
								{conta.sandbox && <em className="badge-teste">Teste</em>}
								{!conta.sandbox && conta.contaId === contaAtivaId && <em className="badge-ativa">Ativa</em>}
							</span>
						</div>
						<div className="info">
							<label>Chave secreta</label>
							<span className="key">{conta.secretKeyMasked}</span>
						</div>
						<div className="actions">
							<button
								type="button"
								className="outline"
								disabled={saving || validatingId === conta.contaId}
								onClick={() => handleValidateConta(conta.contaId)}
							>
								{validatingId === conta.contaId ? "Verificando..." : "Verificar chave"}
							</button>
							<button
								type="button"
								className="primary"
								disabled={saving || conta.contaId === contaAtivaId || conta.sandbox}
								onClick={() => handleActivate(conta)}
							>
								Usar esta conta
							</button>
							<button type="button" disabled={saving} onClick={() => handleEdit(conta)}>Editar</button>
							<button type="button" className="danger" disabled={saving} onClick={() => handleRemove(conta)}>Remover</button>
						</div>
					</div>
				))}
			</div>

			<h3>
				<span className="new">{editingId ? "EDITAR" : "NOVO"}</span>
				{editingId ? "Atualizar conta" : "Cadastrar conta"}
			</h3>

			<form className="new-pagarme-account" onSubmit={handleSave}>
				<div className="grid">
					<div className="field">
						<label htmlFor="pagarme-account-name">Nome da conta</label>
						<div className="input">
							<input
								id="pagarme-account-name"
								type="text"
								value={formState.nome}
								onChange={(e) => setFormState({ ...formState, nome: e.target.value })}
								placeholder="Ex: Conta principal"
							/>
						</div>
					</div>
					<div className="field">
						<label htmlFor="pagarme-account-key">Chave secreta</label>
						<div className="input">
							<input
								id="pagarme-account-key"
								type="password"
								value={formState.secretKey}
								onChange={(e) => setFormState({ ...formState, secretKey: e.target.value })}
								placeholder={editingId ? "Deixe em branco para manter a chave atual" : "Cole a chave secreta da Pagarme"}
								autoComplete="new-password"
							/>
						</div>
						{editingId && (
							<p className="hint">Deixe em branco para manter a chave atual.</p>
						)}
					</div>
				</div>
				<div className="actions">
					<button type="button" className="outline" disabled={saving || validatingForm} onClick={handleValidateForm}>
						{validatingForm ? "Verificando..." : "Verificar chave"}
					</button>
					<button type="submit" className="addnew" disabled={saving}>
						{saving ? "Salvando..." : editingId ? "Salvar alterações" : "Cadastrar conta"}
					</button>
					{editingId && (
						<button type="button" className="cancel" disabled={saving} onClick={resetForm}>Cancelar</button>
					)}
				</div>
			</form>
		</div>
	);
}

const mapStateToProps = (state) => ({
	loja: state.configuracao.loja,
	usuario: state.auth.usuario,
});

export default connect(mapStateToProps, configsActions)(ConfigPayments);
